var DragInProgress = false;

class DraggableSvgItem {
	constructor(editor) {
		this.listenerManager = new ListenerManager();
		this.namespace = "http://www.w3.org/2000/svg";

		// position the object was clicked
		this.dragx = 0;
		this.dragy = 0;

		// position of cursor in the svg
		this.posx = 0;
		this.posy = 0;

		// is this svgItem currently dragged
		this.isActive = false;

		// width and height of MiniMe
		this.svgHeight = 798;
		this.svgWidth = 450;

		//position drag started
		this.startx = 0;
		this.starty = 0;
		this.lastDrag = 0;

		this.editor = editor;
	}

	addListeners() {
		this.item.style.userSelect = "none";
		this.listenerManager.safeObserve(this.item, "mousedown", this.dragStart.bind(this));
		this.listenerManager.safeObserve(this.editor, "mousemove", this.drag.bind(this));
		this.listenerManager.safeObserve(this.editor, "mouseup", this.dragStop.bind(this));

		//Mobile
		if (legacyGlobal.isTouchDevice()) {
			this.listenerManager.safeObserve(this.item, "touchstart", this.dragStart.bind(this));
			this.listenerManager.safeObserve(this.editor, "touchmove", this.drag.bind(this));
			this.listenerManager.safeObserve(this.editor, "touchend", this.dragStop.bind(this));
			this.listenerManager.safeObserve(this.editor, "touchcancel", this.dragStop.bind(this));
		}
	}

	dragStart(e) {
		this.pauseEvent(e);

		this.startx = this.item.getAttribute("x");
		this.starty = this.item.getAttribute("y");

		this.isActive = true;
		DragInProgress = true;

		if (legacyGlobal.isTouchDevice() && e.type === "touchstart") {
			this.posx = e.touches[0].pageX;
			this.posy = e.touches[0].pageY;
		}

		this.dragx = this.posx - this.item.getAttribute("x");
		this.dragy = this.posy - this.item.getAttribute("y");

		return false;
	}

	dragStop(e) {
		if (this.isActive) {
			this.isActive = false;
			DragInProgress = false;
		}
	}

	drag(e) {
		if (this.isActive) {
			this.pauseEvent(e);
		}

		var now = new Date();
		if (now.getTime() - this.lastDrag > 70) {
			if (legacyGlobal.isTouchDevice() && e.type === "touchmove") {
				this.posx = e.touches[0].pageX;
				this.posy = e.touches[0].pageY;
			} else {
				this.posx = document.all ? e.clientX : e.pageX;
				this.posy = document.all ? e.clientY : e.pageY;
			}

			if (this.isActive) {
				var newX = this.posx - this.dragx;
				var newY = this.posy - this.dragy;
				var width = parseFloat(this.item.getAttribute("width"));
				var height = parseFloat(this.item.getAttribute("height"));

				// don't drag over left/top border
				if (newX + width / 2 < 0) newX = -1 * width / 2;
				if (newY + height / 2 < 0) newY = -1 * height / 2;

				// don't drag over right/bottom border
				if (newX + width / 2 > this.svgWidth) newX = this.svgWidth - width / 2;
				if (newY + height / 2 > this.svgHeight) newY = this.svgHeight - height / 2;

				this.item.setAttribute("x", Math.round(newX));
				this.item.setAttribute("y", Math.round(newY));
				now = new Date();
				this.lastDrag = now.getTime();
			}
		}

		return false;
	}

	pauseEvent(e) {
		if (typeof(e) == "undefined") return;

		if (e.stopPropagation) e.stopPropagation();
		if (e.preventDefault) e.preventDefault();
		e.cancelBubble = true;
		e.returnValue = false;
		return false;
	}
}
